'use strict';

// This directive prevents focus to the element it is placed on by adding
// tabindex="-1" and aria-hidden="true". These attributes will prevent the user
// from reaching the element using the [tab] key, and will hide it from screen readers.

// Focus will be prevented if this directive is used with no input, or if 'true' is passed in.
// Passing in 'false' will make the element focusable again.

// If the element already has a tabindex when this directive is linked,
// it will save it. Later, if the input is changed from 'true' to 'false',
// the previouse tabindex will be reapplied.


(function () {
  'use strict';

  angular.module('msCore').directive('msPreventFocusHere', msPreventFocusHere);

  msPreventFocusHere.$inject = ['$log'];

  function msPreventFocusHere($log) {
    var directive = {
      restrict: 'A',
      link: link
    };

    function link(scope, element, attrs) {

      var previousTabindex = element[0].getAttribute('tabindex');

      if (_.isUndefined(attrs.msPreventFocusHere)) {
        changeElTabindex(element[0], -1);
      }

      // Observe the bound input param and when it's TRUE,
      // we prohibit tabbing to this thing by setting tabindex to -1,
      // otherwise we allow tabbing.
      attrs.$observe('msPreventFocusHere', function (newVal) {
        if (scope.$eval(newVal)) {
          changeElTabindex(element[0], -1);
        } else {
          changeElTabindex(element[0], previousTabindex);
        }
      });
    }

    function changeElTabindex(el, newIndex) {
      if (_.isInteger(parseInt(newIndex)) && newIndex === -1) {
        el.setAttribute('tabindex', newIndex);
        el.setAttribute('aria-hidden', true);
      } else if (parseInt(newIndex) >= 0) {
        el.setAttribute('tabindex', newIndex);
        el.removeAttribute('aria-hidden');
      } else if (newIndex === null) {
        el.removeAttribute('tabindex');
        el.removeAttribute('aria-hidden');
      } else {
        $log.error('Something isn\'t right. Check your tabindex: ', newIndex);
      }
    }

    return directive;
  }
})();